import 'css-chunksrc/client/pages/projectPage/resourcesPage/resource/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_ixpmy_1",
  "input": "_input_ixpmy_5",
  "openedInput": "_openedInput_ixpmy_21",
  "iconOpen": "_iconOpen_ixpmy_27",
  "iconClose": "_iconClose_ixpmy_36",
  "listRoot": "_listRoot_ixpmy_44",
  "list": "_list_ixpmy_44",
  "role": "_role_ixpmy_1",
  "textHidden": "_textHidden_ixpmy_68",
  "selectedRole": "_selectedRole_ixpmy_73",
  "selectedRoleIcon": "_selectedRoleIcon_ixpmy_77",
  "selectedRoleTitle": "_selectedRoleTitle_ixpmy_83",
  "roleDescription": "_roleDescription_ixpmy_90",
  "readOnly": "_readOnly_ixpmy_95"
};